class BarComponentRegistry {

    constructor({getLabel}) {
        this.topBarComponents = []
        this.sidebarTabs = []
        this.sidebarComponents = []

        this._getLabel = getLabel
    }

    /**
     *
     *
     * @param {string} id
     * @param {object} definition
     * @param {Component} component
     */
    addPopoverComponent(id, definition, component) {
        definition.align = definition.align === 'left' ? 'left' : 'right'
        definition.button = definition.button || false

        if (!definition.icon && !definition.title) {
            throw new Error('Popover trigger must have a default icon or title')
        }

        // Props handed over to popover when created
        this.topBarComponents.push({
            id: id,
            type: 'popover',
            icon: definition.icon,
            title: definition.title,
            button: definition.button,
            align: definition.align,
            sticky: definition.sticky || false,
            css: definition.css || {},
            component: component
        })
    }

    /**
     *
     * @param {string} id
     * @param {object} definition
     * @param {Component} component
     */
    addTopBarComponent(id, definition, component) {
        definition.align = definition.align === 'left' ? 'left' : 'right'

        // Props handed over to popover when created
        this.topBarComponents.push({
            id: id,
            type: 'component',
            align: definition.align,
            component: component
        })
    }

    /**
     *
     * @param {string} tabId
     * @param {object} pluginConfig
     * @param {Component} component
     */
    addToSidebar(tabId, pluginConfig, component) {
        const {tab, id} = pluginConfig
        tabId = tab ? tab : tabId

        this._addSidebarTab(tabId, this._getLabel(tabId))
        this._addComponentToSidebarWithTabId(id, tabId, component, pluginConfig)
    }

    /**
     * @returns {*[]}
     */
    getSideBars() {
        return this.sidebarTabs
    }

    /**
     *
     * @param {array} tabOrder - Array of strings representing tabIds in the order they should be returned
     * @returns {*[]}
     */
    getOrderedSideBars(tabOrder = []) {
        const tabs = this.getSideBars()
        const orderedTabs = tabOrder
            .filter((tabName) => tabs.find(({id}) => id === tabName))
            .map((tabName) => tabs.find(({id}) => id === tabName))

        const unorderedTabs = tabs.filter(({id}) => !tabOrder.includes(id))

        return [...orderedTabs, ...unorderedTabs]
    }

    /**
     * Returns a registered sidebarPanels
     * @returns {Array}
     */
    getSidebarComponents() {
        return this.sidebarComponents
    }

    getTopbarComponents() {
        return this.topBarComponents
    }

    /**
     * Adds a tab to the right sidebar
     *
     * @param {string} id
     * @param {string} name
     * @private
     */
    _addSidebarTab(id, name) {
        if (!this.sidebarTabs.find(({id: tabId}) => tabId === id)) {
            this.sidebarTabs.push({
                id,
                name
            })
        }
    }

    /**
     * Adds a Substance Component to a a panel by specifying the tabId
     *
     * @param {string} id
     * @param {string} tabId
     * @param {Component} component
     * @param {object} pluginConfigObject Pass the plugin config object
     * @private
     */
    _addComponentToSidebarWithTabId(id, tabId, component, pluginConfigObject) {
        if (typeof component.render !== 'function') {
            throw new Error('Ui must be an instance of Component and have a render function')
        }

        // Is this ever used?
        // this.addComponent(`${id}-tab`, component)

        this.sidebarComponents.push({
            id,
            tabId,
            component,
            pluginConfigObject,
            getCSSFriendlyName: () => id.replace(/\./g, '-')
        })
    }

}

export {BarComponentRegistry}
